import React, { useEffect, useState } from "react";
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import { EmtIcon } from "./EmtIcon";
import { EmtFormLabelCaption } from "./EmtFormLabelCaption";

export type EmtCheckboxProps = CheckboxProps & {
  label?: string;
  caption?: string | React.ReactNode | React.ReactNode[];
  error?: boolean;
  helperText?: string;
  controlledCheckbox?: boolean;
  variant?: string; // Allow any string for custom colors
  nonce?: string;
};

export function EmtCheckbox(props: EmtCheckboxProps) {
  const {
    checked,
    onChange,
    disableRipple,
    icon,
    checkedIcon,
    indeterminateIcon,
    label,
    caption,
    error,
    helperText,
    controlledCheckbox = true,
    variant, // Use string to allow any color
    ...rest
  } = props;

  const [isChecked, setIsChecked] = useState(checked);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange ? onChange(event, !isChecked) : null;
    setIsChecked((check) => !check);
  };

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const customStyles =
    variant === "purple"
      ? {
          backgroundColor: "#F9F9F9",
          "& .emt-tick": { backgroundColor: "#AE59C6" },
          "& .emt-icons": { borderColor: "#D2D1D4" },
        }
      : {};

  const checkBox = (
    <Checkbox
      {...rest}
      checked={controlledCheckbox ? isChecked : checked}
      onChange={handleChange}
      disableRipple={disableRipple ? disableRipple : true}
      icon={icon ? icon : <EmtIcon className="emt-blank" />}
      checkedIcon={checkedIcon ? checkedIcon : <EmtIcon className="emt-tick" />}
      indeterminateIcon={
        indeterminateIcon ? (
          indeterminateIcon
        ) : (
          <EmtIcon className="emt-minus" />
        )
      }
      sx={{ ...customStyles, ...(rest.sx || {}) }} // Apply styles based on color prop
    />
  );

  return label || caption ? (
    <FormControl error={error}>
      <FormControlLabel
        control={checkBox}
        label={
          <EmtFormLabelCaption
            label={label || ""}
            caption={caption as JSX.Element}
          />
        }
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  ) : (
    checkBox
  );
}
